export default __webpack_public_path__ + "static/SanFranciscoText-Medium-acf228526ec2dc094c56b556523270ac.woff";